import { Dropdown } from 'models/ActionBar/Dropdown';
import styles from './styles.module.scss';

function Item(props : Dropdown) : JSX.Element {

  function getImage() : JSX.Element {
    if(!props.classname)
      return <></>;

    return (
      <div>
        <img className={props.classname}/>
      </div>
    );
  }
  return (
    <div className={styles['biobar-item']}>
      {getImage()}
      <a href={props.url}>
        {props.title}
      </a>
    </div>
  );
}

export default Item;